import { render, staticRenderFns } from "./BoardPostCreate.vue?vue&type=template&id=2dc15b5f&scoped=true"
import script from "./BoardPostCreate.vue?vue&type=script&lang=js"
export * from "./BoardPostCreate.vue?vue&type=script&lang=js"
import style0 from "./BoardPostCreate.vue?vue&type=style&index=0&id=2dc15b5f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc15b5f",
  null
  
)

export default component.exports